(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["desktop-atc-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function(){
  const bar = document.querySelector('[data-desktop-atc]');
  const btn = document.querySelector('[data-desktop-atc-btn]');
  if (!bar || !btn) return;
  const form = document.querySelector('[data-product-form]');
  const hero = document.querySelector('.product-hero-2');
  if (!form || !hero) return;
  btn.addEventListener('click', ()=>{ form.requestSubmit(); });
  function update(){
    const rect = hero.getBoundingClientRect();
    const visible = rect.top < window.innerHeight && rect.bottom > 0; // hero on screen
    bar.hidden = visible; // hide when hero visible
  }
  update();
  document.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-atc-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function(){
  const bar = document.querySelector('[data-atc-sticky]');
  if(!bar) return;
  
  // Show on product pages only when hero exists
  const hero = document.querySelector('.product-hero-2');
  if(!hero) return;
  
  // Find the pharmacy button or primary CTA to scroll to
  const pharmacyButton = document.querySelector('.pharmacy-toggle, .pharmacy-cta');
  const primaryCta = document.querySelector('[data-primary-cta]');
  const directSubmit = hero.querySelector('[data-direct-buy-atc]');
  const directForm = directSubmit && directSubmit.closest('[data-direct-buy-form]');
  const scrollTarget = directForm || pharmacyButton || primaryCta || hero;
  if (directForm) {
    bar.querySelectorAll('[data-atc-sticky-button]').forEach(button => { button.textContent = bar.dataset.addLabel; });
    const meta = bar.querySelector('.atc-sticky__meta');
    if (meta) meta.textContent = bar.dataset.directLabel;
  }
  
  // Update bar visibility based on hero position
  function update(){
    if (!hero) {
      bar.hidden = true;
      return;
    }
    
    const heroBox = hero.getBoundingClientRect();
    // Hero is considered "visible" if any part of it is in the viewport
    // We want to hide the bar when hero is visible (even partially)
    const heroVisible = heroBox.bottom > 0 && heroBox.top < window.innerHeight;
    
    // Show bar ONLY when hero is completely scrolled past (not visible)
    // Hide bar when hero is visible (user scrolled back up)
    const shouldShow = !heroVisible;
    
    // Use both hidden attribute and display style for maximum compatibility
    if (shouldShow) {
      bar.removeAttribute('hidden');
      bar.style.display = '';
    } else {
      bar.setAttribute('hidden', '');
      bar.style.display = 'none';
    }
  }
  
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update(); // Initial check
  
  // Button click handler - open modal on mobile, scroll on desktop
  const buttons = bar.querySelectorAll('[data-atc-sticky-button]');
  const modal = document.querySelector('[data-pharmacy-modal]');
  
  // Helper to check if mobile
  function isMobile() {
    return window.innerWidth <= 768;
  }
  
  // Modal handlers
  function openModal() {
    if (modal) {
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
  }
  
  function closeModal() {
    if (modal) {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = ''; // Restore scrolling
    }
  }
  
  // Close modal handlers
  if (modal) {
    const closeButtons = modal.querySelectorAll('[data-pharmacy-modal-close]');
    closeButtons.forEach(closeBtn => {
      closeBtn.addEventListener('click', closeModal);
    });
    
    // Close on overlay click
    const overlay = modal.querySelector('.pharmacy-modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }
    
    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });
  }
  
  // Button click handler - Desktop only (mobile handled by inline onclick)
  buttons.forEach(btn => {
    btn.addEventListener('click', function(e){
      if (directForm) {
        e.preventDefault();
        const submit = directForm.querySelector('[data-direct-buy-atc]');
        if (submit && !submit.disabled) directForm.requestSubmit(submit);
        return;
      }
      if (isMobile()) { e.preventDefault(); openModal(); return; }
      
      e.preventDefault();
      
      // Desktop: scroll to pharmacy button
      if (scrollTarget) {
        // Smooth scroll to the target with offset for sticky header
        const headerOffset = 100; // Adjust based on your header height
        const elementPosition = scrollTarget.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        
        // Optional: Add a subtle highlight effect to the button
        if (pharmacyButton) {
          pharmacyButton.style.transition = 'all 0.3s ease';
          pharmacyButton.style.transform = 'scale(1.05)';
          setTimeout(() => {
            pharmacyButton.style.transform = 'scale(1)';
          }, 300);
        }
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
